const Config = {
  title: 'Chicas al Frente',
  twitter: 'https://twitter.com/ChicasAlFrente_',
  url: 'https://chicasalfrente.com',
  logo: 'https://chicasalfrente.com/img/logo.svg'
  
}

export default Config